import { jsx as _jsx } from "react/jsx-runtime";
import { flow } from 'lodash';
import { mergeStyles } from '@fluentui/react';
import { useInjectedHtmlStyles } from './useInjectedHtmlStyles';
/**
 * Raw HTML inserter with scrubbing for common cross-site-scripting attacks
 * and uber basic fluent styling.
 *
 * > Have some raw HTML that you need to put on the page? Don't use
 * > dangerouslySetInnerHtml, use this component instead. It has a built-in
 * > sanitizer
 *
 * @see MarkdownBlock to render Markdown content rather t
 */
export const HtmlBlock = ({ styles, text }) => {
    const defaultStyles = useInjectedHtmlStyles();
    //Functional programming is fun
    const result = flow([require('dompurify').sanitize, replaceOldUpdateGuide])(text);
    const className = mergeStyles(defaultStyles, styles === null || styles === void 0 ? void 0 : styles.root);
    return (
    // This component does XSS sanitization.
    // eslint-disable-next-line react/no-danger
    _jsx("div", { className: className, dangerouslySetInnerHTML: { __html: result } }) // CodeQL [SM03712] This is a false positive. We're using the DOMPurify library to sanitize the text. The explicit purpose of this component is to prevent XSS attacks.
    );
};
/**
 * Replaces links to the old MSRC security update guide
 *
 * @param {string} text input text
 * @returns {string}
 */
const replaceOldUpdateGuide = (text) => {
    const here = window.location.href.replace(window.location.pathname, '') +
        '/update-guide';
    return text === null || text === void 0 ? void 0 : text.replace(/((http|https):\/\/)?portal.msrc.microsoft.com/gi, here);
};
